type BundleOptionValue = {
  presentation_info?: { product?: { is_discontinued?: boolean | null } | null } | null;
};

type BundleOption = {
  values?: (BundleOptionValue | null | undefined)[] | null;
};

type ProductWithBundleOptions = {
  bundle_options?: (BundleOption | null | undefined)[] | null;
};

export const hasBundleDiscontinuedProduct = (item: ProductWithBundleOptions): boolean => {
  const bundleOptions = item.bundle_options ?? [];

  return bundleOptions.some((bundleOption) => {
    const values = bundleOption?.values ?? [];
    return values.some((value) => value?.presentation_info?.product?.is_discontinued);
  });
};
